var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("MAXIMUM BENEFIT LIMIT (MBL)")]),_c('h4',[_vm._v("The maximum liability that HMI shall cover and assume per covered Illness or Injury of a Member within the term of this Agreement. MBL is replenished upon renewal of the Agreement by Client but not during any extension thereof.")])])
}]

export { render, staticRenderFns }